<template>
    <div class="library-index">
        <div class="contain">
            <el-row class="l-content">
                <!-- 上方按钮 -->
                <el-row class="button-group">
                    <el-button
                        size="small"
                        icon="el-icon-search"
                        @click="searchB()"
                        class="more-search-css"
                    ></el-button>
                    <el-input
                        placeholder="请输入关键字搜索"
                        v-model="searchInput"
                        class="search-input"
                        v-show="showS"
                        @input="keyWords(searchInput,lb)"
                    ></el-input>
                    <el-button
                        size="small"
                        v-for="(item, index) in seachButtonH"
                        :key="index"
                        :class="item.checked?'select-checked':'no-checked'"
                        @click="select(item)"
                    >{{ item.name }}</el-button>
                    <el-dropdown trigger="click" @command="select1" v-if="seachButtonD.length">
                        <el-button size="small" :class="more?'select-checked':'no-checked'">
                            更多
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                v-for="(item, index) in seachButtonD"
                                :key="index"
                                :command="item"
                                :class="item.checked?'select-checked':'no-checked'"
                            >{{item.name }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-row>
                <el-row :gutter="22">
                    <!-- 左边图书列表 -->
                    <el-col :span="18" style="min-height:100px">
                        <el-row :gutter="20">
                            <el-col
                                :span="6"
                                class="bookList"
                                v-for="(item, index) in bookList"
                                :key="index"
                            >
                                <div @click="wenkuD(item.id)" class="shou">
                                    <el-card class="box-card">
                                        <div class="one-book">
                                            <img
                                                src="../assets/img/13.png"
                                                alt
                                                style="width:100%"
                                                v-if="index == '0'||index == '4'||index == '8'"
                                            />
                                            <img
                                                src="../assets/img/14.png"
                                                alt
                                                style="width:100%"
                                                v-if="index == '1'||index == '5'||index == '9'"
                                            />
                                            <img
                                                src="../assets/img/15.png"
                                                alt
                                                style="width:100%"
                                                v-if="index == '2'||index == '6'||index == '10'"
                                            />
                                            <img
                                                src="../assets/img/16.png"
                                                alt
                                                style="width:100%"
                                                v-if="index == '3'||index == '7'||index == '11'"
                                            />
                                            <div
                                                class="one-book-title-box start-left-right-end-shu"
                                            >{{ item.name }}</div>
                                        </div>
                                        <div class="book-detail">
                                            <div class="top-title">
                                                {{limitMaxWords(5,item.name)}}
                                                <span
                                                    class="author"
                                                >{{ item.author }}</span>
                                            </div>
                                            <div class="summary">{{limitMaxWords(25,item.zhaiyao) }}</div>
                                        </div>
                                    </el-card>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <!-- 右边收藏列表 -->
                    <el-col :span="6">
                        <el-row class="l-r-ul-li">
                            <el-col :span="24">
                                <div class="collection-title" style="margin-bottom:20px" @click="collectFAll()">
                                    <img src="../assets/img/shoucang.png" alt /> 我的收藏
                                    <img src="../assets/img/shuangjiantou.png" alt  class="right-arrow" />
                                </div>
                                <div class="collection-title haveRead">
                                    <img src="../assets/img/book.png" alt /> 已读文章
                                </div>
                                <ul class="l-ul">
                                    <li
                                        v-for="(item,index) in merdiansNameList"
                                        :key="index"
                                        @click="wenkuD(item.id)"
                                    >{{item.name+item.chapter}}</li>
                                </ul>
                            </el-col>
                        </el-row>
                        <div class="right-list">
                            <div class="collection-title">
                                <img src="../assets/img/hot.png" alt /> 热门书籍
                            </div>
                            <div class="list-two clearfix">
                                <el-row
                                    type="flex"
                                    class="row-bg"
                                    justify="space-between"
                                    v-for="(item,index) in hotList"
                                    :key="index"
                                    v-if="index % 2 == 0"
                                >
                                    <el-col :span="11" style="margin-bottom:10px">
                                        <div
                                            class="position-relative"
                                            @click="wenkuD(hotList[index].id)"
                                        >
                                            <img
                                                src="../assets/img/iconbook1.png"
                                                alt
                                                style="width:100%"
                                                v-if="index == 0"
                                            />
                                            <img
                                                src="../assets/img/iconbook3.png"
                                                alt
                                                style="width:100%"
                                                v-if="index == 2"
                                            />

                                            <div
                                                class="name-div start-left-right-end-shu"
                                            >{{hotList[index].name}}</div>
                                        </div>
                                        <div class="hot-title-j">{{hotList[index].name}}</div>
                                        <div
                                            class="hot-intro-j"
                                        >{{limitMaxWords(8,hotList[index].zhaiyao)}}</div>
                                    </el-col>
                                    <el-col :span="11" v-if="index<hotList.length-1">
                                        <div
                                            class="position-relative"
                                            @click="wenkuD(hotList[index+1].id)"
                                        >
                                            <img
                                                src="../assets/img/iconbook2.png"
                                                alt
                                                style="width:100%"
                                                v-if="index+1 == 1"
                                            />
                                            <img
                                                src="../assets/img/iconbook4.png"
                                                alt
                                                style="width:100%"
                                                v-if="index+1 == 3"
                                            />
                                            <div
                                                class="name-div start-left-right-end-shu"
                                            >{{hotList[index+1].name}}</div>
                                        </div>
                                        <div class="hot-title-j">{{hotList[index+1].name}}</div>
                                        <div
                                            class="hot-intro-j"
                                        >{{limitMaxWords(8,hotList[index+1].zhaiyao)}}</div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-row>
            <el-row>
                <el-col>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pageInfo4.total"
                        :page-size="pageInfo4.pageSize"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: "LibraryIndex",
    data() {
        return {
            wordslist: [
                // {
                //     name: "本草纲目 第一章"
                // },
                // {
                //     name: "本草纲目 第一章"
                // },
                // {
                //     name: "本草纲目 第一章"
                // },
                // {
                //     name: "本草纲目 第一章"
                // }
            ],
            searchInput: "", //文本框搜索内容
            showS: false, //搜索框不显示
            lb: "", //分类名字
            more: false, //更多没有选中
            seachButtonH: [], //搜索横着显示的
            seachButtonD: [], //搜索竖着显示的
            bookList: [], // 文库列表
            merdiansNameList: [], //已读的文章列表
            hotList: [] //热门推荐数组
        };
    },
    methods: {
        //选页
        handleCurrentChange(v) {
            let that = this;
            // console.log(v);
            that.pageInfo4.pageNum = v; //当前页
            that.getList(that.searchInput, that.lb, v);
        },
        //文库详情
        wenkuD(id) {
            this.$router.push({
                path: "/weiKuDetail",
                query: { id: id }
            });
        },
        //搜索按钮
        searchB() {
            let that = this;
            if (that.showS) {
                that.showS = false;
            } else {
                that.showS = true;
            }
        },
        //searchInput搜索框
        keyWords(searchInput) {
            let that = this;
            // 将全部选择效果删除
            for (let c of that.seachButtonH) {
                if (c.id == "全部") {
                    c.checked = false;
                }
            }
            this.getList(searchInput, that.lb);
        },
        //得到搜索的条件
        getSearchButton() {
            let that = this;
            let url = "/medicineLibraryCategory/categoryList";
            that.$http
                .post(url)
                .then(res => {
                    if (res.data.code == 200) {
                        that.seachButtonH = [];
                        that.seachButtonD = [];
                        let arr = [];
                        arr = res.data.data;
                        for (let i = 0; i < arr.length; i++) {
                            if (i < 8) {
                                that.isDisplay = false;
                                if (arr[i].id == "全部") {
                                    that.seachButtonH.push({
                                        id: arr[i].id,
                                        name: arr[i].name,
                                        checked: true
                                    });
                                } else {
                                    that.seachButtonH.push({
                                        id: arr[i].id,
                                        name: arr[i].name,
                                        checked: false
                                    });
                                }
                            } else {
                                that.isDisplay = true;
                                that.seachButtonD.push({
                                    id: arr[i].id,
                                    name: arr[i].name,
                                    checked: false
                                });
                            }
                            // console.log(that.seachButtonH);
                            // console.log(that.seachButtonD);
                        }
                    } else {
                        that.$message(res.data.msg);
                    }
                })
                .catch(() => {
                    // that.$message.error("网络错误！");
                });
        },
        //searchInput搜索框,lb文库分类编号
        getList(searchInput, lb, pageNum) {
            let that = this;
            if (pageNum) {
                that.pageInfo4.pageNum = pageNum;
            } else {
                that.pageInfo4.pageNum = 1;
            }
            // console.log("文本框关键字:" + searchInput);
            // console.log("文库分类id:" + lb);
            // console.log("当前页:" + pageNum);
            let url = "/medicineLibraryBooks/pageByCategory";
            let parmas = {
                category: lb,
                name: searchInput,
                pageNum: that.pageInfo4.pageNum,
                pageSize: that.pageInfo4.pageSize
            };
            that.$http
                .post(url, parmas)
                .then(res => {
                    if (res.data.code == 200) {
                        that.pageInfo4.total = res.data.data.total;
                        that.pageInfo4.pageSize = res.data.data.pageSize;
                        that.bookList = [];
                        that.bookList = res.data.data.list.map(
                            (item, index) => {
                                return {
                                    id: item.id,
                                    author: item.author,
                                    name: item.name,
                                    stance_img: item.stance_img,
                                    zhaiyao: that.limitMaxWords(
                                        20,
                                        item.zhaiyao
                                    )
                                };
                            }
                        );
                    } else {
                        that.$message(res.data.msg);
                    }
                })
                .catch(() => {
                    // that.$message("网络错误！");
                });
        },
        // 横向选择
        select(v) {
            let that = this;
            for (let c of that.seachButtonH) {
                c.checked = false;
            }
            v.checked = true;
            if (v.id == "全部") {
                that.searchInput = "";
            }
            that.more = false;
            that.lb = v.id;
            for (let c of that.seachButtonD) {
                c.checked = false;
            }
            that.getList(that.searchInput, that.lb);
        },
        // 纵向选择
        select1(command) {
            let that = this;
            for (let c of that.seachButtonD) {
                c.checked = false;
            }
            command.checked = true;
            that.more = true;
            that.lb = command.id;
            for (let c of that.seachButtonH) {
                c.checked = false;
            }
            that.getList(that.searchInput, that.lb);
        },
        //已读文章列表
        getReadList() {
            let that = this;
            let url = "/medicineLibraryBooks/medicineLibraryChapterReadList";
            let parmas = {};
            that.$http
                .post(url, parmas)
                .then(res => {
                    if (res.data.code == 200) {
                        that.merdiansNameList = [];
                        that.merdiansNameList = res.data.data.map(
                            (item, index) => {
                                return {
                                    chapter: item.chapter,
                                    name: item.name,
                                    id: item.id
                                };
                            }
                        );
                    } else {
                        that.$message(res.data.msg);
                    }
                })
                .catch(() => {
                    // that.$message("网络错误！");
                });
        },
        //热门推荐
        hotCommond() {
            let that = this;
            let url = "/medicineLibraryBooks/findMedicineLibraryBooksListHot";
            that.$http
                .post(url)
                .then(res => {
                    if (res.data.code == 200) {
                        that.hotList = [];
                        that.hotList = res.data.data.map((item, index) => {
                            return {
                                id: item.id,
                                author: item.author,
                                name: item.name,
                                zhaiyao: item.zhaiyao,
                                stanceImg: item.stanceImg
                            };
                        });
                    } else {
                        that.$message(res.data.msg);
                    }
                })
                .catch(() => {
                    // that.$message("网络错误！");
                });
        },
         //我的收藏
        collectFAll() {
            if (!this.isLoginF()) return false;
            this.$router.push({
                path: "/myCollection",
                query: { i: 2 }
            });
        }
    },
    created() {
        let that = this;
        that.getList();
        that.getSearchButton();
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
           
                that.getReadList();
        }
        that.hotCommond();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hot-title-j {
    color: #333333;
    font-size: 14px;
}
.hot-intro-j {
    color: #666666;
    font-size: 12px;
}
.no-checked {
    /* border: none; */
    margin-bottom: 0px;
}
.position-relative {
    position: relative;
}

.list-one > div {
    line-height: 50px;
    border-bottom: 2px dotted #e9e9e9;
    color: #666666;
    cursor: pointer;
}
.list-two > div {
    /* width: 100px;
    height: 125px; */
    background-repeat: no-repeat;
    /* float: left; */
    /* margin-top: 10px; */
    cursor: pointer;
    position: relative;
}
/* .list-two > div:nth-child(1) {
    margin-right: 10px;
    background-image: url("../assets/img/iconbook1.png");
}
.list-two > div:nth-child(2) {
    background-image: url("../assets/img/iconbook2.png");
}
.list-two > div:nth-child(3) {
    margin-right: 10px;
    background-image: url("../assets/img/iconbook3.png");
}
.list-two > div:nth-child(4) {
    background-image: url("../assets/img/iconbook4.png");
} */
.list-one,
.list-two {
    padding: 12px;
}
.right-list {
    /* margin-top: 20px; */
    border: 2px solid #e9e9e9;
}
.right-list .collection-title {
    background-color: #e9e9e9;
    border-bottom: solid 1px #dddddd;
    color: #333333;
}
.collection-title {
    height: 24px;
    line-height: 24px;
    padding: 13px;
    background-color: #f64420;
    color: #ffffff;
    text-align: left;
    padding-left: 20px;
    cursor: pointer;
}
/* .collection-title img:nth-child(2) {
    margin-left: 80px;
} */
.collection-title img {
    vertical-align: middle;
}

.button-group {
    /* text-align: center; */
    padding: 20px 0px 30px;
}
.button-group .el-button:nth-of-type(1){
    margin-left:0 ;
}
.button-group .el-button:hover {
    background-color: #f64420;
    color: white;
    border: 1px solid white;
}
.one-book-title-box {
    /* width: 18%; */
    height: 57%;
    padding: 1.5% 0px;
    background-color: #ffffff;
    border: solid 1px #6c6b69;
    font-size: 22px;
    /* line-height: 40px; */
    letter-spacing: 4px;
    color: #444444;
    position: absolute;
    top: 19%;
    left: 34%;
    text-align: center;
    word-wrap: break-word;
}
.name-div {
    /* width: 14%; */
    height: 66px;
    padding: 3px 0px;
    background-color: #ffffff;
    border: solid 1px #6c6b69;
    font-size: xx-small;
    /* line-height: 17px; */
    color: #444444;
    position: absolute;
    top: 19%;
    left: 38%;
    text-align: center;
    /* cursor: pointer; */
    word-wrap: break-word;
}
.one-book {
    /* width: 272px;
    height: 340px; */
    position: relative;
}
/* .box-card {
    background-repeat: no-repeat;
    background-image: url("../assets/img/13.png");
    margin-bottom: 20px;
} */
/* .box-card:nth-child(1) {
  background-image: url("../assets/img/13.png");
}
.box-card:nth-child(2) {
  background-image: url("../assets/img/14.png");
}
.box-card:nth-child(3) {
  background-image: url("../assets/img/15.png");
}
.box-card:nth-child(4) {
  background-image: url("../assets/img/16.png");
} */
/* .el-card {
    width: 272px;
    float: left;
} */
.el-card:not(:last-child) {
    margin-right: 17.5px;
}
.book-detail {
    padding: 0px 10px;
    min-height: 80px;
}
.book-detail .top-title {
    width: 100%;
    font-size: 17px;
    /* line-height: 40px;
    letter-spacing: 1.8px; */
    color: #333333;
    padding:3px 0px;
}
.book-detail .author {
    display: block;
    float:right;
    max-width: 40%;
    white-space: nowrap; /* 禁止文本换行，使其在一行内显示 */
    overflow: hidden; /* 隐藏超出容器宽度的部分 */
    text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
    font-size: 14px;
    /* line-height: 40px; */
    letter-spacing: 1.4px;
    color: #666666;
}
.book-detail .summary {
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 3.0em;
    /* letter-spacing: 1.4px; */
    color: #999999;
}
.bookList {
    margin-bottom: 10px;
}

/* .contain {
    max-width: 100% !important;
} */
.haveRead{
    background-color: #e9e9e9;
    border-bottom: solid 1px #dddddd;
    color: #333333;
}
.right-arrow{
    float: right;
    padding: 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/LibraryIndex.vue